import { usePushNotifications } from '@/hooks/usePushNotifications';
import { onMessage } from 'firebase/messaging';
import { useEffect } from 'react';
import { messaging } from '../../../firebase/firebase';

export const PushNotificationSetup = () => {
  const { isSubscribed } = usePushNotifications();

  useEffect(() => {
    if (isSubscribed) {
      const unsubscribe = onMessage(messaging, (payload) => {
        const { title, body, icon } = payload.notification || {};
        const notificationOptions = {
          body,
          icon: icon || '/favicon.png',
          data: payload.data,
        };

        new Notification(title || 'New Notification', notificationOptions);
      });

      return () => unsubscribe();
    }
  }, [isSubscribed]);

  return null;
};
